var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.settings.status == 'pending' || _vm.settings.status == 'draft')?_c('div',[_c('soon',{attrs:{"settings":_vm.settings}})],1):_c('div',[_c(_vm.settings.listing_style,{key:_vm.settings.listing_style,tag:"component"}),_c('pv-mobile-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }